const ChartRoute = {
  name: 'Chart',
  path: '/organization-chart/chart',
  component: () => import('@/views/OrganizationChart/Chart.vue'),
}
export default ChartRoute